import AbstractRequestTask from './AbstractRequestTask';
import RequestManager from '../RequestManager';
import WorkflowStartTask from './WorkflowStartTask';

class PurchaseButtonSuscTask extends AbstractRequestTask {
  constructor(params) {
    super();
    this.params = params;
  }

  getUrl() {
    const urlDominioMicrofwk = window.getConfig.url_dominio_microfwk;
    return `${urlDominioMicrofwk}services/payway/purchasebuttoninfo`;
  }

  getParams() {
    const params = super.getParams();
    this.params = Object.assign(params, this.params);

    return params;
  }

  passErrorToRequest = true;

  success(data, b) {
    const self = this;
    const isValid = super.success(data, b);
    if (!isValid) {
      const newdata = super.parseErrors(data);
      return this.reject(newdata, b);
    }

    const payTypes = data.response.listButtons.button;
    // Preset request to get pay modes for each pay type
    const workflowStartRequests = [];
    const { offer_id = false } = this.request.params;
    payTypes.map(payType => {
      if (offer_id && offer_id !== payType.offerid) {
        return;
      }

      const workflowStartTask = new WorkflowStartTask({
        offer_id: payType.offerid,
        linkworkflowstart: payType.linkworkflowstart,
      });

      workflowStartRequests.push(
        RequestManager.addRequest(workflowStartTask).then(
          res => res,
          err => err,
        ),
      );

      return payType;
    });

    // Make request asynchronous
    return Promise.all(workflowStartRequests)
      .then(results => {
        // Match with payTypes TODO: Improve performance

        const errors = results.filter(result => result.errors);
        if (errors.length) return Promise.reject(errors[0]);
        payTypes.map(payType => {
          if (offer_id && offer_id != payType.offerid) {
            return;
          }

          results.map(result => {
            let confirm = result.response.messageConfirmSuscription;
            if (result.msg && result.msg == 'ERROR')
              confirm = result.errors.error[0] || result.errors.error;

            if (payType.offerid == result.entry.offer_id) {
              payType.payModes = result.response.list;
              payType.selectedPaymentMethod =
                result.response.selectedPaymentMethod || null;

              payType.gatewayInfo = {
                hasUserSusc: result.response.hasUserSusc || undefined,
                hasSavedPayway: result.response.hasSavedPayway || undefined,
                gateway: result.response.gateway || undefined,
                statusCreditCard: result.response.statusCreditCard || undefined,
                cardNumber: result.response.cardNumber || undefined,
                titleSusc:
                  result.response.tittleConfirmSuscription || undefined,
                messageConfirm: confirm || undefined,
                messageConfirmExtra:
                  result.response.messageConfirmSuscriptionExtra || undefined,
                wfs: {
                  linkworkflowstart: payType.linkworkflowstart,
                  offer_id: payType.offerid,
                },
              };
            }
          });
          return payType;
        });
        self.resolve({ payTypes });
      })
      .catch(err => {
        const newdata = super.parseErrors(err);
        return this.reject({ ...newdata }, b);
      });
  }
}

export default PurchaseButtonSuscTask;
